import React from 'react';
import './Footer.css';

function Footer(){

    return (
        <div>
           <footer className="Footer">
               <h4>&copy; 2020 My React, all rights reserved</h4>
           </footer>
        </div>
    );
}

export default Footer;